import { PhoneIconForDevices } from '../../icons'

export default function NewPaybarPlusPhone() {
  return (
    <div className="newPaybarPlusPhone">
      <PhoneIconForDevices />
    </div>
  )
}
